import gql from 'graphql-tag'

export const insertContactsCategory = ({ category }) => {
	return {
		mutation: gql`
			mutation ($category: contacts_categories_insert_input!) {
				insert_contacts_categories_one(object: $category) {
					id
				}
			}
		`,
		variables: { category }
	}
}
